import React, { useEffect, useState, useMemo } from "react";
import { Card, CardBody, Col, Container, Row, Input, Label, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TabelaEspacos from "./consulta";
import { api } from "../../../config";
import Loader from "../../../Components/Common/Loader";
import { fetchComAuthJson } from "../../../common/api"; 
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";

const STORAGE_KEY = "last_feira_selecionada_espacos";

const ListaEspacos = ({ feiraId: propFeiraId }) => {
  const [dados, setDados] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const authUser = useMemo(() => JSON.parse(sessionStorage.getItem("authUser")) || {}, []);
  const userData = authUser.user || authUser;
  
  // const feirasOptions = useMemo(() => {
  //   return userData.feiras?.map(f => ({
  //     value: f.feira_id.toString(),
  //     label: f.feira?.nome || `Feira ${f.feira_id}`
  //   })) || [];
  // }, [userData]);

  const feirasOptions = useMemo(() => {
    const feirasUsuario = userData.feiras || [];
    const listaPermissoes = userData.permissoes?.permissoes || [];

    if (['JOTAPIX', 'EVOMAP'].includes(userData.perfil)) {
      return feirasUsuario.map(f => ({
        value: f.feira_id.toString(),
        label: f.feira?.nome || `Feira ${f.feira_id}`
      }));
    }

    return feirasUsuario
      .filter(f => {
        return listaPermissoes.some(p => 
          p.chave === "CADASTRO_ESPAÇOS" && p.feira === f.feira_id
        );
      })
      .map(f => ({
        value: f.feira_id.toString(),
        label: f.feira?.nome || `Feira ${f.feira_id}`
      }));
  }, [userData]);

  const [feiraSelecionada, setFeiraSelecionada] = useState(() => {
    if (propFeiraId) return propFeiraId;

    if (feirasOptions.length === 1) return feirasOptions[0].value;

    const salva = localStorage.getItem(STORAGE_KEY);
    if (salva && feirasOptions.some(f => f.value === salva)) {
      return salva;
    }

    return "";
  });

  const fetchDados = async (id) => {
    if (!id) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${api.API_URL}/feira/estandes/${id}`, { method: 'GET' });
      const json = await response.json();

      if (!response.ok) throw new Error("Erro ao buscar os dados");
      
      setDados(json.data || []);
      setError(null);
    } catch (error) {
      setError(error.message);
      setDados([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFeiraChange = (val) => {
    setFeiraSelecionada(val);
    if (!propFeiraId) { 
        localStorage.setItem(STORAGE_KEY, val);
    }
  };

  useEffect(() => {
    if (feiraSelecionada) {
      fetchDados(feiraSelecionada);
    }
  }, [feiraSelecionada]);

  useEffect(() => {
    if (feirasOptions.length > 0 && !feiraSelecionada) {
      setFeiraSelecionada(feirasOptions[0].value);
    }
  }, [feirasOptions, feiraSelecionada]);

  const handleDeleteSpace = async (id) => {
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feira/estande/${id}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        toast.success("Espaço excluído com sucesso!");
        setDados(prev => prev.filter(item => item.id !== id));
      } else {
        toast.error("Erro ao excluir o espaço.");
      }
    } catch (e) {
      toast.error("Erro de comunicação com o servidor.");
    }
  };

  return (
    <div className={!propFeiraId ? "page-content" : ""}>
      
      {!propFeiraId && (<ToastContainer closeButton={false} />)}

      <Container fluid>
        {!propFeiraId && <BreadCrumb title="Lista de Espaços" pageTitle="Processos" />}
        
        <Row>
          <Col lg={12}>
            <Card>
              
              {!propFeiraId && (
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col md={4}>
                      <Label className="form-label">Selecione a Feira</Label>
                      
                      <Input 
                        type="select" 
                        value={feiraSelecionada} 
                        onChange={(e) => handleFeiraChange(e.target.value)} 
                      >
                        <option value="">Selecione uma feira...</option>
                        {feirasOptions.map(f => (
                          <option key={f.value} value={f.value}>{f.label}</option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                </CardHeader>
              )}
              
              <CardBody>
                {!feiraSelecionada ? (
                  <div className="text-center py-5">
                    <i className="ri-building-2-line fs-1 text-muted"></i>
                    <h5 className="mt-3">Nenhuma feira selecionada</h5>
                    <p className="text-muted">Escolha uma feira no seletor acima para visualizar os espaços.</p>
                  </div>
                ) : isLoading ? (
                  <Loader />
                ) : error ? (
                  <Loader error={error} />
                ) : (
                  <TabelaEspacos 
                    data={dados} 
                    onDelete={handleDeleteSpace} 
                    feiraId={feiraSelecionada} 
                    isFeiraContext={!!propFeiraId}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListaEspacos;